import { render, staticRenderFns } from "./Zimmereinteilung.vue?vue&type=template&id=76ace6bc"
import script from "./Zimmereinteilung.vue?vue&type=script&lang=js"
export * from "./Zimmereinteilung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports